import { useState } from "react";
import { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { Field } from "react-final-form";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import BMXTextField from "../../../../../../Components/Inputs/BMXTextField/BMXTextField";
import RolesItem from "../../../../../../Components/RolesItem/RolesItem";
import { GlobalAuthFetch } from "../../../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import { Icon, IconButton, Tooltip } from "@mui/material";
import BMXPopover from "../../../../../../Components/BMXPopover/BMXPopover";
import BMXSeparator from "../../../../../../Components/Separator/BMXSeparator";
import "./RolesFormStepOne.scss"

const PersonInRoles = (props) => {
  const { workers } = props;
  const { t } = useTranslation();

  return <div className="PersonInRoles m-3">
    <BMXSeparator title={t("global:roles.rolestoworker")} />
    <ul style={{ overflow: "auto", maxHeight: "200px", listStyleType: "disc" }}>
      {workers.map(el => <li>{`${el.firstName || ""} ${el.lastName || ""}`}</li>)}
    </ul>
  </div>
}

const RolesFormStepOne = (props) => {
  const { selected, setSelected } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [registry, setRegistry] = useState([]);
  const [workers, setWorkers] = useState([]);

  const attachmentRights = {
    name: t("global:roles.attachment.name"), icon: "attach_file ", rights: [
      {
        "uuid": "49fbcfc9-0d48-4532-a58a-3b7405ac2137",
        "name": "ATTACHMENT_DELETE"
      },                
      {
        "uuid": "a1185cdc-3a99-2137-b11d-d5c28d9f0405",
        "name": "ATTACHMENT_UPDATE"
      }
    ]
  }

  useEffect(() => {
    const fetchData = async () => {
     const fetchArray = [
        GlobalAuthFetch({ path: "/registry/allSelected" })
      ]
      if(Boolean(props.values.uuid)){ 
      fetchArray.push(GlobalAuthFetch({ path: `/worker/getWorkersByRoleId/${props.values.uuid}` }))
      }

      const { 0: resRegistry, 1: resWorker } = await Promise.all(fetchArray);
      setRegistry([...resRegistry?.payload?.data,attachmentRights]);
      if (resWorker?.payload) {
        setWorkers(resWorker?.payload?.data)
      }
    };
    fetchData();
  }, [dispatch]);

  return (
    <div className="justify-content-start">
      <Row>
        <Col xs={Boolean(props.values.uuid) ? 10 : 12}>
          <Field
            data-cy="roleName"
            name="name"
            label={t("global:roles.name")}
            component={BMXTextField}
          />
        </Col>
        {Boolean(props.values.uuid) ?
          <Col xs={2}>
            <BMXPopover popoverOptions={{
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'center',
              },
              transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
              }
            }} icon={<Tooltip title={t("global:roles.pesons")}>
              <IconButton edge="start">
                <Icon>person</Icon>
              </IconButton>
            </Tooltip>}>
              <PersonInRoles workers={workers} />
            </BMXPopover>

          </Col> : null
        }
      </Row>
      <div className="RolesList overflow-auto">
        {registry &&
          registry.length > 0 &&
          registry.map((el) => (
            <RolesItem values={selected} setValues={setSelected} key={el.uuid}>
              {el}
            </RolesItem>
          ))}
        {/* <RolesItem values={selected}  setValues={setSelected} >Secretartuy</RolesItem> */}
      </div>
    </div>
  );
};

export default RolesFormStepOne;
